import { EXTRA_QUESTIONS } from "./questions-extra";

export type JSide = "left" | "right";

export interface Question {
  id: number;
  scene: string;
  left: string;
  right: string;
  jSide: JSide;
  characters?: readonly string[];
}

export const QUIZ_LENGTH = 16;
export const QUESTIONS_PER_SIDE = QUIZ_LENGTH / 2;

export const QUESTIONS: readonly Question[] = [
  {
    id: 1,
    scene: "小羊在群里说：‘这周末搞点事？’",
    left: "先问时间地点，大概怎么安排",
    right: "先扣 1，细节到时候再说",
    jSide: "left",
    characters: ["小羊"],
  },
  {
    id: 2,
    scene: "小羊又抛出一个活动脑洞",
    left: "先把人摇起来，其他边聊边定",
    right: "先捋成一个能执行的小方案",
    jSide: "right",
    characters: ["小羊"],
  },
  {
    id: 3,
    scene: "群里投票选活动日期",
    left: "先挑个顺眼的，能来就来",
    right: "把大家空闲时间统计完再定",
    jSide: "right",
  },
  {
    id: 4,
    scene: "投票半天还是平票",
    left: "设个截止时间，到点直接定",
    right: "不急，再聊聊没准有新答案",
    jSide: "left",
  },
  {
    id: 5,
    scene: "活动当天，壮老师突然说‘我也来’",
    left: "立刻把人数和预订更新一下",
    right: "来呗，多个人多份快乐",
    jSide: "left",
    characters: ["壮老师"],
  },
  {
    id: 6,
    scene: "棒老师开场前随机刷新",
    left: "这才是群活动隐藏彩蛋",
    right: "先确认座位和东西够不够",
    jSide: "right",
    characters: ["棒老师"],
  },
  {
    id: 7,
    scene: "大胡二胡老师同时说‘活动可能来’",
    left: "分别确认一下，到底来几位",
    right: "先按两位算，来几个算几个",
    jSide: "left",
    characters: ["二胡老师"],
  },
  {
    id: 8,
    scene: "活动快开始了，还有人没回消息",
    left: "先出发，路上再等消息",
    right: "把名单和集合时间再确认一遍",
    jSide: "right",
  },
  {
    id: 9,
    scene: "杭州突然放晴，有人喊看落日",
    left: "包去的，发个定位我就出门",
    right: "先查日落时间和返程路线",
    jSide: "right",
  },
  {
    id: 10,
    scene: "出门五分钟，杭州突然下雨",
    left: "马上换个室内方案",
    right: "先躲躲，说不定一会儿就停",
    jSide: "left",
  },
  {
    id: 11,
    scene: "周末想来一场 citywalk",
    left: "随便选个起点，走到哪算哪",
    right: "先把路线和休息点串起来",
    jSide: "right",
  },
  {
    id: 12,
    scene: "西湖边突然人山人海",
    left: "立刻切备用路线，别硬挤",
    right: "来都来了，边走边看吧",
    jSide: "left",
  },
  {
    id: 13,
    scene: "玩得正开心，但末班地铁快到了",
    left: "先继续玩，到时候再看",
    right: "现在就定好几点撤",
    jSide: "right",
  },
  {
    id: 14,
    scene: "到了店门口，发现要排一个小时",
    left: "换家没吃过的，开个新副本",
    right: "看看备选清单，去下一家",
    jSide: "right",
  },
  {
    id: 15,
    scene: "在杭州突然多出半天空闲",
    left: "翻翻待办，把想做的排上",
    right: "先出门，今天交给随机事件",
    jSide: "left",
  },
  {
    id: 16,
    scene: "赵老师说下次从北京来杭州",
    left: "先把日期和行程早早对上",
    right: "人到了再组，杭州随时能开局",
    jSide: "left",
    characters: ["赵老师"],
  },
  {
    id: 17,
    scene: "群活动开着，赵老师在北京围观",
    left: "随时连线，想到哪聊到哪",
    right: "提前留一个固定的远程环节",
    jSide: "right",
    characters: ["赵老师"],
  },
  {
    id: 18,
    scene: "鹅崽终于从新疆放假回来",
    left: "提前把欢迎局的时间定下来",
    right: "回来群里一喊，谁在谁来",
    jSide: "left",
    characters: ["鹅崽"],
  },
  {
    id: 19,
    scene: "想让新疆的鹅崽也参加一次活动",
    left: "先开视频，现场自由发挥",
    right: "提前定时间和线上玩法",
    jSide: "right",
    characters: ["鹅崽"],
  },
  {
    id: 20,
    scene: "小叶老师突然说：‘我有个想法’",
    left: "先听，群里最不缺新副本",
    right: "先问清楚时间、地点和人数",
    jSide: "right",
    characters: ["小叶老师"],
  },
  {
    id: 21,
    scene: "红老师发来一张双十一优惠表",
    left: "研究明白，按最优方案下单",
    right: "看个大概，差不多便宜就行",
    jSide: "left",
    characters: ["红老师"],
  },
  {
    id: 22,
    scene: "红老师算出三套不同买法",
    left: "随便挑一套，省到就是赚到",
    right: "再核一遍，选总价最低的",
    jSide: "right",
    characters: ["红老师"],
  },
  {
    id: 23,
    scene: "双十一购物车已经塞满",
    left: "照着提前列的清单买",
    right: "边刷边加，今晚全凭感觉",
    jSide: "left",
  },
  {
    id: 24,
    scene: "双十一规则临时变了",
    left: "重新算一遍，再决定怎么买",
    right: "算不动了，主打一个随缘下单",
    jSide: "left",
  },
  {
    id: 25,
    scene: "离优惠结束只剩十分钟",
    left: "最后十分钟才是我的主场",
    right: "该买的早买完了，退出软件",
    jSide: "right",
  },
  {
    id: 26,
    scene: "乱讲 PPT 大赛开始报名",
    left: "先报上，主题以后再想",
    right: "先想好讲什么，再决定报不报",
    jSide: "right",
  },
  {
    id: 27,
    scene: "打开 PPT，却还没想好主题",
    left: "先定标题和大纲",
    right: "先做两页，灵感自己会来",
    jSide: "left",
  },
  {
    id: 28,
    scene: "比赛只剩三天",
    left: "DDL 前的我，强得可怕",
    right: "按之前的进度正常收尾",
    jSide: "right",
  },
  {
    id: 29,
    scene: "做到一半，突然想到更好玩的主题",
    left: "换！好玩比较重要",
    right: "先把这版做完，新主题留到下次",
    jSide: "right",
  },
  {
    id: 30,
    scene: "前一个人讲了和你类似的梗",
    left: "快速调整顺序和重点",
    right: "没事，上台临场接住这个梗",
    jSide: "left",
  },
  {
    id: 31,
    scene: "轮到你上台乱讲 PPT",
    left: "大致按排好的节奏讲",
    right: "看现场反应，想到哪讲到哪",
    jSide: "left",
  },
  {
    id: 32,
    scene: "要给盲盒饮料活动挑一瓶饮料",
    left: "闭眼拿个没喝过的，主打惊喜",
    right: "先打听一下，尽量别撞款",
    jSide: "right",
  },
  {
    id: 33,
    scene: "发现自己和别人买了同款饮料",
    left: "撞就撞吧，这叫双倍快乐",
    right: "我去换一个，保持每款不同",
    jSide: "right",
  },
  {
    id: 34,
    scene: "盲盒饮料的规则还没定",
    left: "先把数量、预算和玩法写清楚",
    right: "大家先带来，现场自然会玩",
    jSide: "left",
  },
  {
    id: 35,
    scene: "所有盲盒饮料都摆上桌了",
    left: "随手抽一个，喝到什么是什么",
    right: "先编号，再按顺序抽",
    jSide: "right",
  },
  {
    id: 36,
    scene: "群友把简历丢进群里求修改",
    left: "先问投什么岗位，再一条条看",
    right: "先打开看看，哪儿有感觉改哪儿",
    jSide: "left",
  },
  {
    id: 37,
    scene: "大家对同一句简历描述意见不一",
    left: "再多聊几种写法也行",
    right: "先定一版，别卡在这一句",
    jSide: "right",
  },
  {
    id: 38,
    scene: "改简历时突然想到全新的方向",
    left: "先把这一版改完，新方向另存",
    right: "这个好，干脆推倒重来",
    jSide: "left",
  },
  {
    id: 39,
    scene: "对方明天就要投简历",
    left: "今晚集中火力，极限救一下",
    right: "先排优先级，只改最重要的",
    jSide: "right",
  },
  {
    id: 40,
    scene: "群里约着去径山寺",
    left: "路线、天气和要带的先查好",
    right: "先接龙，其他临近再说",
    jSide: "left",
  },
  {
    id: 41,
    scene: "到了径山寺，原计划的路走不通",
    left: "来都来了，随缘逛也挺好",
    right: "先找替代路线，重新安排",
    jSide: "right",
  },
  {
    id: 42,
    scene: "去求佛前，要写想求的东西",
    left: "提前想好，到了直接许愿",
    right: "见到佛再说，现场更有感觉",
    jSide: "left",
  },
  {
    id: 43,
    scene: "群历写着‘今日宜去径山寺’",
    left: "玄学批准，直接开冲",
    right: "先看看日期和路线，再安排上",
    jSide: "right",
  },
  {
    id: 44,
    scene: "KTV 还剩最后半小时",
    left: "把最后几首先排好，体面收尾",
    right: "继续加歌，唱不到就下次",
    jSide: "left",
  },
  {
    id: 45,
    scene: "KTV 点歌台已经排了几十首",
    left: "继续加，唱不到算下次",
    right: "清一清，只留下真想唱的",
    jSide: "right",
  },
  {
    id: 46,
    scene: "KTV 结束，有人突然提议续摊",
    left: "我还是按原计划回家",
    right: "可以，今晚主打一个不设上限",
    jSide: "left",
  },
  {
    id: 47,
    scene: "二胡老师发出今日幸运词：‘冲鸭’",
    left: "可以冲，但先说清楚冲哪儿",
    right: "冲就完了，边走边说",
    jSide: "left",
    characters: ["二胡老师"],
  },
  {
    id: 48,
    scene: "二胡老师的群历写着‘今日宜看落日’",
    left: "收到，今天随机触发落日副本",
    right: "先查几点日落，再塞进今天安排",
    jSide: "right",
    characters: ["二胡老师"],
  },
  {
    id: 49,
    scene: "二胡老师说‘今日忌查银行卡余额’",
    left: "今天不查，说到做到",
    right: "手已经点开了，忌就是宜",
    jSide: "left",
    characters: ["二胡老师"],
  },
  {
    id: 50,
    scene: "二胡老师说‘今日幸运随身物：奶茶’",
    left: "先选好喝哪家，再安排顺路去买",
    right: "看到哪家买哪家，幸运会自己来",
    jSide: "left",
    characters: ["二胡老师"],
  },
  {
    id: 51,
    scene: "刚搬去上海的卷突然说：‘我今天回杭州’",
    left: "收到，晚上谁有空谁来",
    right: "先问待多久，再把时间地点定了",
    jSide: "right",
    characters: ["卷"],
  },
  {
    id: 52,
    scene: "活动名单快截止，阿jo还在潜水",
    left: "没报名就先按现有名单定",
    right: "给阿jo留个机动位，没准会刷新",
    jSide: "left",
    characters: ["阿jo"],
  },
  {
    id: 53,
    scene: "群里发了新活动，牙刷老师没有出现",
    left: "先在群里喊，看到就随缘来",
    right: "直接私聊确认，来不来给个准信",
    jSide: "right",
    characters: ["牙刷老师"],
  },
  {
    id: 54,
    scene: "大家聊活动聊出十几个支线，赵老师开始 cue 流程",
    left: "很好，先把主线和下一步定了",
    right: "别急，支线说不定更好玩",
    jSide: "left",
    characters: ["赵老师"],
  },
  {
    id: 55,
    scene: "群里准备去上海找卷玩",
    left: "交通、住宿和见面时间先对好",
    right: "先买票，落地再找卷碰头",
    jSide: "left",
    characters: ["卷"],
  },
  {
    id: 56,
    scene: "阿jo突然冒泡，狂夸乱讲 PPT",
    left: "被夸出灵感，再加两页",
    right: "收到夸夸，按原版收尾",
    jSide: "right",
    characters: ["阿jo"],
  },
  {
    id: 57,
    scene: "私聊牙刷老师后，收到一句‘应该可以’",
    left: "那就留个随机刷新位",
    right: "再确认时间，把人加进名单",
    jSide: "right",
    characters: ["牙刷老师"],
  },
  {
    id: 58,
    scene: "小羊刚发活动脑洞，赵老师就问‘流程呢’",
    left: "立刻补上时间线和分工",
    right: "先把人摇齐，流程以后再说",
    jSide: "left",
    characters: ["小羊", "赵老师"],
  },
  {
    id: 59,
    scene: "你画到一半，卷突然提议整张换个风格",
    left: "换！灵感来了就跟着走",
    right: "先把这张画完，新风格开下一张",
    jSide: "right",
    characters: ["卷"],
  },
  {
    id: 60,
    scene: "阿jo对两个活动方案都一顿夸",
    left: "夸归夸，还是投票定一个",
    right: "两个都好，先都留着",
    jSide: "left",
    characters: ["阿jo"],
  },
  {
    id: 61,
    scene: "计划去 KTV，牙刷老师还没在群里回",
    left: "先开，牙刷老师出现就是彩蛋",
    right: "安排一个人私聊，把人数确认掉",
    jSide: "right",
    characters: ["牙刷老师"],
  },
  {
    id: 62,
    scene: "活动进行中，赵老师从北京远程 cue 下一环节",
    left: "现场气氛正好，再玩一会儿",
    right: "时间差不多了，按流程往下走",
    jSide: "right",
    characters: ["赵老师"],
  },
  {
    id: 63,
    scene: "卷从上海发来消息，临时想换见面地点",
    left: "马上更新路线和集合信息",
    right: "没事，跟着新定位走",
    jSide: "left",
    characters: ["卷"],
  },
  {
    id: 64,
    scene: "阿jo对你改的每个简历版本都夸",
    left: "都留着，不同岗位也许都能用",
    right: "选出最合适的一版，今天定稿",
    jSide: "right",
    characters: ["阿jo"],
  },
  {
    id: 65,
    scene: "牙刷老师活动当天突然说‘我来了’",
    left: "马上补人数、座位和分组",
    right: "来就行，神秘嘉宾成功刷新",
    jSide: "left",
    characters: ["牙刷老师"],
  },
  {
    id: 66,
    scene: "活动比预计慢了半小时，赵老师提醒流程",
    left: "这段正上头，晚点也没关系",
    right: "压缩后面的环节，把时间拉回来",
    jSide: "right",
    characters: ["赵老师"],
  },
  {
    id: 67,
    scene: "卷发来一张没画完的画，让大家起名",
    left: "先收几个候选，今天定一个",
    right: "继续接龙，名字越多越好",
    jSide: "left",
    characters: ["卷"],
  },
  {
    id: 68,
    scene: "潜水半天的阿jo突然出现：‘你们都好棒’",
    left: "成功被夸夸硬控，先聊起来",
    right: "收下夸夸，继续刚才的正事",
    jSide: "right",
    characters: ["阿jo"],
  },
  {
    id: 69,
    scene: "牙刷老师私聊说想来，但时间还不确定",
    left: "约个最晚确认时间",
    right: "没事，能来就随机刷新",
    jSide: "left",
    characters: ["牙刷老师"],
  },
  {
    id: 70,
    scene: "活动结束，赵老师开始 cue 复盘",
    left: "趁热把结论和下次改进记下来",
    right: "先快乐散场，复盘以后再说",
    jSide: "left",
    characters: ["赵老师"],
  },
  ...EXTRA_QUESTIONS,
] as const;

const QUESTION_BY_ID = new Map(QUESTIONS.map((question) => [question.id, question]));

export function getQuestionById(id: number): Question | undefined {
  return QUESTION_BY_ID.get(id);
}

function shuffled<T>(items: readonly T[], random: () => number): T[] {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const unit = Math.min(Math.max(random(), 0), 0.9999999999999999);
    const randomIndex = Math.floor(unit * (index + 1));
    [result[index], result[randomIndex]] = [
      result[randomIndex] as T,
      result[index] as T,
    ];
  }
  return result;
}

export function createQuestionSet(random: () => number = Math.random): number[] {
  const usedCharacters = new Set<string>();
  const selected: Question[] = [];

  for (const side of ["left", "right"] as const) {
    let sideCount = 0;
    const candidates = shuffled(
      QUESTIONS.filter((question) => question.jSide === side),
      random,
    );
    for (const question of candidates) {
      if (sideCount >= QUESTIONS_PER_SIDE) break;
      const characters = question.characters ?? [];
      if (characters.some((character) => usedCharacters.has(character))) continue;
      selected.push(question);
      sideCount += 1;
      characters.forEach((character) => usedCharacters.add(character));
    }
  }

  if (selected.length !== QUIZ_LENGTH) {
    throw new Error("Question pool cannot produce a balanced quiz.");
  }

  return shuffled(selected, random).map((question) => question.id);
}

export function validateQuestionSet(value: unknown): value is number[] {
  if (!Array.isArray(value) || value.length !== QUIZ_LENGTH) return false;
  if (!value.every((id) => Number.isInteger(id) && QUESTION_BY_ID.has(id))) {
    return false;
  }
  if (new Set(value).size !== QUIZ_LENGTH) return false;

  const questions = value.map((id) => QUESTION_BY_ID.get(id));
  const leftCount = questions.filter((question) => question?.jSide === "left").length;
  if (leftCount !== QUESTIONS_PER_SIDE) return false;

  const characters = questions.flatMap((question) => question?.characters ?? []);
  return new Set(characters).size === characters.length;
}

export const CHOICE_LABELS = [
  "完全同意左边的做法",
  "同意左边的做法",
  "比较同意左边的做法",
  "两种都可以",
  "比较同意右边的做法",
  "同意右边的做法",
  "完全同意右边的做法",
] as const;
